 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER101INVERSION from '@/components/0_chapter101inversion'
 import A_CHAPTER102SWEEP from '@/components/1_chapter102sweep'
 import A_CHAPTER103WILLINGTOADMITDEFEAT from '@/components/2_chapter103willingtoadmitdefeat'
 import A_CHAPTER104BEGENEROUSTOOTHERS from '@/components/3_chapter104begeneroustoothers'
 import A_CHAPTER105PROGLACIALAVERSION from '@/components/4_chapter105proglacialaversion'
 import A_CHAPTER106BACKHOME from '@/components/5_chapter106backhome'
 import A_CHAPTER107HOME from '@/components/6_chapter107home'
 import A_CHAPTER108SHOCKEDTWOELDERS from '@/components/7_chapter108shockedtwoelders'
 import A_CHAPTER109CRABGRAB from '@/components/8_chapter109crabgrab'
 import A_CHAPTER110EXPOSEDHAND from '@/components/9_chapter110exposedhand'
 import A0_CHAPTER111ENERGETIC from '@/components/10_chapter111energetic'
 import A1_CHAPTER112THEOLDMANSHOWEDOFFHISPOWER from '@/components/11_chapter112theoldmanshowedoffhispower'
 import A2_CHAPTER113TREATMENT from '@/components/12_chapter113treatment'
 import A3_CHAPTER114MANEATINGFLOWER from '@/components/13_chapter114maneatingflower'
 import A4_CHAPTER115THEMAGNIFICENTEMPERORQING from '@/components/14_chapter115themagnificentemperorqing'
 import A5_CHAPTER116SPIRITGATHERINGARRAYDISC from '@/components/15_chapter116spiritgatheringarraydisc'
 import A6_CHAPTER117PHENOMENOLOGY from '@/components/16_chapter117phenomenology'
 import A7_CHAPTER118SUCCESS from '@/components/17_chapter118success'
 import A8_CHAPTER119GALE from '@/components/18_chapter119gale'
 import A9_CHAPTER120SURPRISEVILLAGERS from '@/components/19_chapter120surprisevillagers'
 import A0_CHAPTER121PROTECTIONFEE from '@/components/20_chapter121protectionfee'
 import A1_CHAPTER122INVERSIONOFTHESITUATION from '@/components/21_chapter122inversionofthesituation'
 import A2_CHAPTER123UPPERHEAVENREALM from '@/components/22_chapter123upperheavenrealm'
 import A3_CHAPTER124NUWA from '@/components/23_chapter124nuwa'
 import A4_CHAPTER125PUPPETTECHNIQUE from '@/components/24_chapter125puppettechnique'
 import A5_CHAPTER126PALEOGENE from '@/components/25_chapter126paleogene'
 import A6_CHAPTER127CONSPIRACY from '@/components/26_chapter127conspiracy'
 import A7_CHAPTER128BUMPINTO from '@/components/27_chapter128bumpinto'
 import A8_CHAPTER129ASSIGN from '@/components/28_chapter129assign'
 import A9_CHAPTER130GHOST from '@/components/29_chapter130ghost'
 import A0_CHAPTER131SCARECROWVICTORY from '@/components/30_chapter131scarecrowvictory'
 import A1_CHAPTER132OPPOSINGMONOCULAREYE from '@/components/31_chapter132opposingmonoculareye'
 import A2_CHAPTER133SCARECROWWEIGHTED from '@/components/32_chapter133scarecrowweighted'
 import A3_CHAPTER134ALARM from '@/components/33_chapter134alarm'
 import A4_CHAPTER135ALARM from '@/components/34_chapter135alarm'
 import A5_CHAPTER136THEPOLICEAREHERE from '@/components/35_chapter136thepolicearehere'
 import A6_CHAPTER137SUSPECT from '@/components/36_chapter137suspect'
 import A7_CHAPTER138THECLUEWASBROKEN from '@/components/37_chapter138thecluewasbroken'
 import A8_CHAPTER139EXPERTS from '@/components/38_chapter139experts'
 import A9_CHAPTER140VISIT from '@/components/39_chapter140visit'
 import A0_CHAPTER141SPECIALTEA from '@/components/40_chapter141specialtea'
 import A1_CHAPTER142CONDITION from '@/components/41_chapter142condition'
 import A2_CHAPTER143SPIRITUALCONCENTRATIONARRAY from '@/components/42_chapter143spiritualconcentrationarray'
 import A3_CHAPTER144JADE from '@/components/43_chapter144jade'
 import A4_CHAPTER145COMPANY from '@/components/44_chapter145company'
 import A5_CHAPTER146SHOCK from '@/components/45_chapter146shock'
 import A6_CHAPTER147IMPARTING from '@/components/46_chapter147imparting'
 import A7_CHAPTER148THIEF from '@/components/47_chapter148thief'
 import A8_CHAPTER149SEDUCTION from '@/components/48_chapter149seduction'
 import A9_CHAPTER150DESPERATETOTAKETHERISK from '@/components/49_chapter150desperatetotaketherisk'
 import A0_CHAPTER151DARKNIGHTSHADOW from '@/components/50_chapter151darknightshadow'
 import A1_CHAPTER152BANDITS from '@/components/51_chapter152bandits'
 import A2_CHAPTER153BUY from '@/components/52_chapter153buy'
 import A3_CHAPTER154CHEAPAPPRENTICE from '@/components/53_chapter154cheapapprentice'
 import A4_CHAPTER155DECISIONABOVE from '@/components/54_chapter155decisionabove'
 import A5_CHAPTER156CONVERSATION from '@/components/55_chapter156conversation'
 import A6_CHAPTER157CONSPIRACY from '@/components/56_chapter157conspiracy'
 import A7_CHAPTER158VIP from '@/components/57_chapter158vip'
 import A8_CHAPTER159PURPOSE from '@/components/58_chapter159purpose'
 import A9_CHAPTER160CONSPIRACYRISE from '@/components/59_chapter160conspiracyrise'
 import A0_CHAPTER161CONSPIRACY from '@/components/60_chapter161conspiracy'
 import A1_CHAPTER162EXPERIMENT from '@/components/61_chapter162experiment'
 import A2_CHAPTER163SHOCKCHANGE from '@/components/62_chapter163shockchange'
 import A3_CHAPTER164HELP from '@/components/63_chapter164help'
 import A4_CHAPTER165FANTONG from '@/components/64_chapter165fantong'
 import A5_CHAPTER166MASTERMIND from '@/components/65_chapter166mastermind'
 import A6_CHAPTER167INVERSION from '@/components/66_chapter167inversion'
 import A7_CHAPTER168BLACKHAND from '@/components/67_chapter168blackhand'
 import A8_CHAPTER169PILLBOY from '@/components/68_chapter169pillboy'
 import A9_CHAPTER170GOSSIPOVEN from '@/components/69_chapter170gossipoven'
 import A0_CHAPTER171ALCHEMY from '@/components/70_chapter171alchemy'
 import A1_CHAPTER172DARKCOOKING from '@/components/71_chapter172darkcooking'
 import A2_CHAPTER173CURES from '@/components/72_chapter173cures'
 import A3_CHAPTER174INTERNALADULTERY from '@/components/73_chapter174internaladultery'
 import A4_CHAPTER175INTERROGATION from '@/components/74_chapter175interrogation'
 import A5_CHAPTER176CAPTURE from '@/components/75_chapter176capture'
 import A6_CHAPTER177UPPERHOOK from '@/components/76_chapter177upperhook'
 import A7_CHAPTER178LUFAMILY from '@/components/77_chapter178lufamily'
 import A8_CHAPTER179LUFAMILYMEETING from '@/components/78_chapter179lufamilymeeting'
 import A9_CHAPTER180STRUGGLE from '@/components/79_chapter180struggle'
 import A0_CHAPTER181AWAKENING from '@/components/80_chapter181awakening'
 import A1_CHAPTER182HOMEAGAIN from '@/components/81_chapter182homeagain'
 import A2_CHAPTER183ZODIACFOETUS from '@/components/82_chapter183zodiacfoetus'
 import A3_CHAPTER184GREATVIGOR from '@/components/83_chapter184greatvigor'
 import A4_CHAPTER185ALIVECAPTURE from '@/components/84_chapter185alivecapture'
 import A5_CHAPTER186RESULTS from '@/components/85_chapter186results'
 import A6_CHAPTER187RELATIVES from '@/components/86_chapter187relatives'
 import A7_CHAPTER188SLIP from '@/components/87_chapter188slip'
 import A8_CHAPTER189OLDPEOPLE from '@/components/88_chapter189oldpeople'
 import A9_CHAPTER190GOTOSCHOOLEARLY from '@/components/89_chapter190gotoschoolearly'
 import A0_CHAPTER191PURCHASE from '@/components/90_chapter191purchase'
 import A1_CHAPTER192SLICEDUP from '@/components/91_chapter192slicedup'
 import A2_CHAPTER193COLLAPSED from '@/components/92_chapter193collapsed'
 import A3_CHAPTER194CULTIVATOR from '@/components/93_chapter194cultivator'
 import A4_CHAPTER195UNFRIENDLYAPPROACH from '@/components/94_chapter195unfriendlyapproach'
 import A5_CHAPTER196AGGRIEVED from '@/components/95_chapter196aggrieved'
 import A6_CHAPTER197BIGNEWS from '@/components/96_chapter197bignews'
 import A7_CHAPTER198AGAIN from '@/components/97_chapter198again'
 import A8_CHAPTER199AGAIN from '@/components/98_chapter199again'
 import A9_CHAPTER200SWORDIMMORTAL from '@/components/99_chapter200swordimmortal'
 import A00_CHAPTER201TRANSFORMATION from '@/components/100_chapter201transformation'
 import A01_CHAPTER202NOINSURANCE from '@/components/101_chapter202noinsurance'
 import A02_CHAPTER203LVDONGBIN from '@/components/102_chapter203lvdongbin'
 import A03_CHAPTER204SWORDTEST from '@/components/103_chapter204swordtest'
 import A04_CHAPTER205THESWORDIMMORTALSSHOCK from '@/components/104_chapter205theswordimmortalsshock'
 import A05_CHAPTER206SECLUSION from '@/components/105_chapter206seclusion'
 import A06_CHAPTER207STRANGELUDONGBIN from '@/components/106_chapter207strangeludongbin'
 import A07_CHAPTER208BLINDWHITESWORD from '@/components/107_chapter208blindwhitesword'
 import A08_CHAPTER209UNABLETOFIGHT from '@/components/108_chapter209unabletofight'
 import A09_CHAPTER210WINNING from '@/components/109_chapter210winning'
 import A10_CHAPTER211GOTCAUGHTINTHEACT from '@/components/110_chapter211gotcaughtintheact'
 import A11_CHAPTER212RETURNTOHEAVENREALM from '@/components/111_chapter212returntoheavenrealm'
 import A12_CHAPTER213GOTIT from '@/components/112_chapter213gotit'
 import A13_CHAPTER214SECRETINFORMATION from '@/components/113_chapter214secretinformation'
 import A14_CHAPTER215IHAVENODAY from '@/components/114_chapter215ihavenoday'
 import A15_CHAPTER216VALLEYS from '@/components/115_chapter216valleys'
 import A16_CHAPTER217SPIRITLIQUID from '@/components/116_chapter217spiritliquid'
 import A17_CHAPTER218QIDEVIATION from '@/components/117_chapter218qideviation'
 import A18_CHAPTER219DEAD from '@/components/118_chapter219dead'
 import A19_CHAPTER220IMONMYHONEYMOON from '@/components/119_chapter220imonmyhoneymoon'
 import A20_CHAPTER221TIANCHENGCUP from '@/components/120_chapter221tianchengcup'
 import A21_CHAPTER222ORIGINALSCHOOLTEAM from '@/components/121_chapter222originalschoolteam'
 import A22_CHAPTER223MATCHSTART from '@/components/122_chapter223matchstart'
 import A23_CHAPTER224ROLLING from '@/components/123_chapter224rolling'
 import A24_CHAPTER225TEASE from '@/components/124_chapter225tease'
 import A25_CHAPTER226FINALE from '@/components/125_chapter226finale'
 import A26_CHAPTER227WULANG from '@/components/126_chapter227wulang'
 import A27_CHAPTER228ENTER from '@/components/127_chapter228enter'
 import A28_CHAPTER229EXTINCTION from '@/components/128_chapter229extinction'
 import A29_CHAPTER230MASSACRE from '@/components/129_chapter230massacre'
 import A30_CHAPTER231ROUTINE from '@/components/130_chapter231routine'
 import A31_CHAPTER232FINALS from '@/components/131_chapter232finals'
 import A32_CHAPTER233CONSPIRACY from '@/components/132_chapter233conspiracy'
 import A33_CHAPTER234MICRONUCLEUS from '@/components/133_chapter234micronucleus'
 import A34_CHAPTER235KILLRACE from '@/components/134_chapter235killrace'
 import A35_CHAPTER236TOTAKETHETOPSPOTAGRANDENDING from '@/components/135_chapter236totakethetopspotagrandending'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter101inversion",
 			"name" : "0_chapter101inversion",
 			"component" : A_CHAPTER101INVERSION
 		},
 		{
 			"path" : "/1_chapter102sweep",
 			"name" : "1_chapter102sweep",
 			"component" : A_CHAPTER102SWEEP
 		},
 		{
 			"path" : "/2_chapter103willingtoadmitdefeat",
 			"name" : "2_chapter103willingtoadmitdefeat",
 			"component" : A_CHAPTER103WILLINGTOADMITDEFEAT
 		},
 		{
 			"path" : "/3_chapter104begeneroustoothers",
 			"name" : "3_chapter104begeneroustoothers",
 			"component" : A_CHAPTER104BEGENEROUSTOOTHERS
 		},
 		{
 			"path" : "/4_chapter105proglacialaversion",
 			"name" : "4_chapter105proglacialaversion",
 			"component" : A_CHAPTER105PROGLACIALAVERSION
 		},
 		{
 			"path" : "/5_chapter106backhome",
 			"name" : "5_chapter106backhome",
 			"component" : A_CHAPTER106BACKHOME
 		},
 		{
 			"path" : "/6_chapter107home",
 			"name" : "6_chapter107home",
 			"component" : A_CHAPTER107HOME
 		},
 		{
 			"path" : "/7_chapter108shockedtwoelders",
 			"name" : "7_chapter108shockedtwoelders",
 			"component" : A_CHAPTER108SHOCKEDTWOELDERS
 		},
 		{
 			"path" : "/8_chapter109crabgrab",
 			"name" : "8_chapter109crabgrab",
 			"component" : A_CHAPTER109CRABGRAB
 		},
 		{
 			"path" : "/9_chapter110exposedhand",
 			"name" : "9_chapter110exposedhand",
 			"component" : A_CHAPTER110EXPOSEDHAND
 		},
 		{
 			"path" : "/10_chapter111energetic",
 			"name" : "10_chapter111energetic",
 			"component" : A0_CHAPTER111ENERGETIC
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js